import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { initPixel, track, captureAttribution } from "@/lib/tracking";
import { LandingHeader, Hero, CredibilityStrip } from "@/components/landing/Hero";
import { ProblemSection, MethodSection, QualifySection } from "@/components/landing/Sections";
import { ProofGallery, PromiseSection, NextStepsSection, LandingFooter } from "@/components/landing/Proof";
import { QualifyForm } from "@/components/landing/QualifyForm";
import { StickyCta } from "@/components/landing/StickyCta";

export default function Landing() {
  const [landing, setLanding] = useState(null);
  const viewed = useRef(false);

  useEffect(() => {
    document.title = "ARK Furniture Revival — See if your furniture qualifies";
    captureAttribution();
    const view = () => {
      if (viewed.current) return;
      viewed.current = true;
      track("LandingPageView");
    };
    axios
      .get(`${API}/public/landing`)
      .then((r) => {
        setLanding(r.data);
        initPixel(r.data.meta_pixel_id);
        view();
      })
      .catch(() => {
        setLanding({ gallery: [] });
        view();
      });
  }, []);

  return (
    <div className="min-h-screen bg-white text-black" data-testid="landing-page">
      <LandingHeader />
      <Hero landing={landing} />
      <CredibilityStrip />
      <ProblemSection beforePhotoId={landing?.gallery?.[0]?.before_photo_id} />
      <MethodSection />
      <QualifySection />
      <ProofGallery gallery={landing?.gallery} />
      <PromiseSection />
      <QualifyForm gallery={landing?.gallery} />
      <NextStepsSection />
      <LandingFooter />
      <StickyCta />
    </div>
  );
}
